import { css } from 'linaria';
export const buttonReset = "b5bt6fr";

require("./button-reset.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./button-reset.js");